import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class VisitorsApprovalsIndexController extends Controller {
  @tracked query = '';
  @tracked start: string | null = null;
  @tracked end: string | null = null;
  @tracked sortBy = 'dueAt';
  @tracked sortDirection: 'asc' | 'desc' = 'asc';

  queryParams = ['end', 'query', 'sortBy', 'sortDirection', 'start'];
}
